import classNames from 'classnames';
import * as React from 'react';
import styles from './Pagination.module.scss';

export interface PaginationTexts {
	paginationTexts: {
		totalResultsText: string;
		showText: string;
		resultsPerPageText: string;
		pageText: string;
		outOfText: string;
		pagesText: string;
		pageSizeAllOption?: string;
	};
	paginationAriaLabels: {
		selectInputAriaLabel: string;
		textInputAriaLabel: string;
		prevButtonAriaLabel: string;
		nextButtonAriaLabel: string;
	};
}
export interface PaginationProps extends PaginationTexts {
	className?: string;
	numberOfItemsTotal: number;
	numberOfPages: number;
	pageSizeOptions?: number[];
	defaultValueIndex?: number;
	currentPageNumber: string;
	errorText?: string;
	onNextPageBtnClick: React.MouseEventHandler;
	onPrevPageBtnClick: React.MouseEventHandler;
	onPageSizeChange: React.ChangeEventHandler;
	onCurrentPageNumberChange: React.ChangeEventHandler;
	onCurrentPageKeyDown?: React.KeyboardEventHandler;
	onCurrentPageBlur?: React.FocusEventHandler;
}

export const Pagination = ({
	className,
	numberOfItemsTotal,
	numberOfPages,
	pageSizeOptions = [10, 20, 30],
	defaultValueIndex = 0,
	currentPageNumber,
	errorText = undefined,
	paginationTexts,
	paginationAriaLabels,
	onNextPageBtnClick,
	onPrevPageBtnClick,
	onPageSizeChange,
	onCurrentPageNumberChange,
	onCurrentPageKeyDown,
	onCurrentPageBlur,
}: PaginationProps): JSX.Element => (
	<div className={classNames(className, styles.Pagination, 'text-nowrap pagination-container')}>
		<div className="cell-one mt-1">
			{numberOfItemsTotal} {paginationTexts.totalResultsText}
		</div>
		<div className="cell-two">
			{paginationTexts.showText}
			<select
				aria-label={paginationAriaLabels.selectInputAriaLabel}
				className="form-control form-control-sm custom-select paginator d-inline text-center no-arrows"
				defaultValue={pageSizeOptions[defaultValueIndex]}
				onChange={onPageSizeChange}
			>
				{pageSizeOptions.map((e) => (
					<option key={e} value={e} className="text-left">
						{e}
					</option>
				))}
				{paginationTexts.pageSizeAllOption && (
					<option value={paginationTexts.pageSizeAllOption} className="text-left">
						{paginationTexts.pageSizeAllOption}
					</option>
				)}
			</select>
			{paginationTexts.resultsPerPageText}
		</div>
		<div className="cell-three">
			{paginationTexts.pageText}
			<input
				type="number"
				max={numberOfPages}
				aria-label={paginationAriaLabels.textInputAriaLabel}
				className={`form-control form-control-sm paginator d-inline text-center no-arrows${!errorText ? '' : ' is-invalid'}`}
				value={currentPageNumber}
				onChange={onCurrentPageNumberChange}
				onKeyDown={onCurrentPageKeyDown}
				onBlur={onCurrentPageBlur}
			/>
			{paginationTexts.outOfText} {numberOfPages ? numberOfPages : 1} {paginationTexts.pagesText}
			<button
				type="button"
				aria-label={paginationAriaLabels.prevButtonAriaLabel}
				className="btn btn-sm btn-primary align-baseline mx-2 pagination-btn"
				disabled={Number(currentPageNumber) === 1 || currentPageNumber === ''}
				onClick={onPrevPageBtnClick}
			>
				<span className="ikon ikon-arrow-left" />
			</button>
			<button
				type="button"
				aria-label={paginationAriaLabels.nextButtonAriaLabel}
				className="btn btn-sm btn-primary align-baseline pagination-btn"
				disabled={Number(currentPageNumber) === numberOfPages}
				onClick={onNextPageBtnClick}
			>
				<span className="ikon ikon-arrow-right" />
			</button>
			{errorText && <div className="invalid-feedback">{errorText}</div>}
		</div>
	</div>
);
